
const FullScreenLoader = ({ text }:any) => {
  return (
    <div className="d-flex justify-content-center align-items-center h-100 py-5">
      <div className="spinner-border" role="status">
        <span className="visually-hidden">{text ?? ""}</span>
      </div>
    </div>
  );
};
export default FullScreenLoader